<template>
  <div class="common_wrap bg_grey color_black relative">
    <div class="main">
      <div v-if="gameUserName" class="account round_5 fs_12 flex_a_c">
        <div class="account_label">已绑定角色</div>
        <!-- <div class="account_value color_yellow">
          {{ gameUserName }}
        </div> -->
      </div>
      <div
        v-for="(gs, gsIdx) in giftList"
        :key="gs.categoryId"
        class="gifts_wrap"
      >
        <div class="gift_title mb_10 mt_12 relative">
          <img :src="require(`@/assets/giftCenter/giftModule${gsIdx % 2}.png`)" alt="">
          <span class="ab_center color_white fs_14 bold">{{ gs.categoryName }}</span>
        </div>
        <div class="gift_list round_5">
          <div
            v-for="gf in gs.giftList"
            :key="gf.id"
            class="gift bg_white round_5"
          >
            <gift-item-1
              :tag="gf.tag"
              :name="gf.giftName"
              :desc="gf.content"
              :condition="'领取条件：' + (gf.condition || '无门槛')"
              :btnText="gf.status === 0 ? '领取' : '查看'"
              :btnColor="gf.status === 1 ? '#1EB75F' : ''"
              @receive="handleReceive(gf)"
            />
          </div>
        </div>
      </div>
    </div>
    <Popup
      :visible.sync="visible"
      v-bind="feedback"
      @confirm="feedback.onSure"
      @cancel="feedback.onCancel"
    >
      <template v-if="feedbackType === 0">
        <div class="color_black mb_4">绑定角色教程:</div>
        <div class="fs_14 color_grey mb_4">返回小游戏点击公众号入口重新进入</div>
        <div
          class="img_container mt_24"
          style="width: 100%"
        >
          <img :src="pic" alt="引导图加载失败" />
        </div>
      </template>
      <template v-if="feedbackType === 2">
        <div
          class="img_container mt_24"
          style="width: 100%; max-height: 300px; overflow: auto;"
        >
          <img :src="curGift.guidePic" alt="引导图加载失败" />
        </div>
      </template>
    </Popup>
  </div>
</template>

<script>
import { getGiftListApi, receiveGiftApi } from '@/apis/activity.api'
import { getGameInfoById } from '@/apis/common.api' 
import Popup from '@/components/Popup.vue';
import GiftItem1 from '@/components/gift/giftItem1.vue';
import store from "@/store";
import trackingMixin, { EVENT_TYPE_ENUM } from "@/mixins/tracking"; 
export default {
  components: {
    GiftItem1,
    Popup,
  },
  mixins: [trackingMixin],
  data () {
    return {
      accountInfo: {},
      giftList: [],
      visible: false,
      feedbackType: 0,
      receiveLoading: false,
      gameUserName: store.getters['user/gameUserName'],
      pic: '',
      gameId: '',
      gameName: '',
      curGift: {},
    }
  },
  mounted () {
    try {
      const params = JSON.parse(localStorage.getItem('wxAuthQuery'))
      this.gameId = this.$route.query.gameId || params.gameId
    } catch (error) {
      this.$toast('参数获取失败')
    }
    this.init()
    // window.onbeforeunload = function (e) {
    //   return confirm("你的更改可能未保存，确定离开吗?");
    // }
  },
  computed: {
    feedbackMap () {
      return [
        {
          title: '未检测到角色绑定',
          confirmButtonText: '我知道了',
          message: [],
          onCancel: () => {},
          onSure: () => {
            const { id, giftName } = this.curGift
            this.EVENT_TRACKING(
              EVENT_TYPE_ENUM.wechat_gift_center_know_button,
              {
                gift_id: id,
                gift_name: giftName,
              },
              this.trackAppInfo
            )
            this.triggerVisible(false)
          },
        },
        {
          title: '领取成功',
          confirmButtonText: '去复制礼包码',
          showCancelButton: true,
          cancelButtonText: '再看看',
          message: [
            `礼包码已存放在`,
            '【我的礼包】--【常规礼包】'
          ],
          onSure: () => {
            const { condition, id, giftId, giftName } = this.curGift
            this.EVENT_TRACKING(
              EVENT_TYPE_ENUM.wechat_gift_center_copy_cdk_button,
              {
                condit: condition ? 1 : 0,
                gift_id: giftId,
                gift_name: giftName,
                id
              },
              this.trackAppInfo
            )
            this.triggerVisible(false)
            this.handleGoMyGift()
          },
          onCancel: () => {
            const { condition, id, giftName } = this.curGift
            this.EVENT_TRACKING(
              EVENT_TYPE_ENUM.wechat_gift_center_see_button,
              {
                condit: condition ? 1 : 0,
                gift_id: id,
                gift_name: giftName,
              },
              this.trackAppInfo
            )
            this.triggerVisible(false)
          }
        },
        {
          title: '未检测到角色绑定',
          confirmButtonText: '我知道了',
          message: [],
          onCancel: () => {},
          onSure: () => {
            this.triggerVisible(false)
          },
        },
      ]
    },
    feedback () {
      return this.feedbackMap[this.feedbackType]
    },
    // 埋点所需的游戏信息
    trackAppInfo () {
      return {
        appkey: this.gameId,
        appName: this.gameName,
      }
    },
  },
  methods: {
    init () {
      this.getMainInfo()
    },
    getMainInfo (hasEvent = true) {
      return getGiftListApi({
        wxappid: this.$storeGet('WX_APP_ID'),
        openid: store.getters['user/openid'],
        gameId: this.gameId,
      }).then(res => {
        if (res.data && Array.isArray(res.data.list)) {
          this.giftList = res.data.list
        }
        if (hasEvent) {
          this.handleGetGameInfo().then(res => {
            this.EVENT_TRACKING(
              EVENT_TYPE_ENUM.wechat_gift_center_page,
              '',
              this.trackAppInfo
            )
          })
        }
      })
    },
    handleReceive (gift = {}) {
      const { id, status, condition, giftName } = gift
      this.curGift = gift
      if (status === 1) {
        this.receiveGiftCallback()
        return
      }
      if (this.receiveLoading) return
      this.receiveLoading = true
      this.EVENT_TRACKING(
        EVENT_TYPE_ENUM.wechat_gift_center_draw_gift_button,
        {
          condit: condition ? 1 : 0,
          gift_id: id,
          gift_name: giftName,
        },
        this.trackAppInfo
      )
      receiveGiftApi({
        wxappid: this.$storeGet('WX_APP_ID'),
        openid: store.getters['user/openid'],
        gameId: this.gameId,
        id,
      }).then(res => {
        const cdk = res.data
        if (cdk) {
          this.receiveGiftCallback()
          this.EVENT_TRACKING(
            EVENT_TYPE_ENUM.wechat_gift_center_draw_gift_success_pop,
            {
              condit: condition ? 1 : 0,
              gift_id: id,
              gift_name: giftName,
            },
            this.trackAppInfo
          )
          // 更新列表
          this.getMainInfo(false)
        } else {
          this.$toast('礼包码已领完')
        }
      }).catch((error) => {
        const { code, msg } = error
        if (code === 6001) {
          this.showGuidingImg({ giftName, id })
          return
        }
        if (code === 6002) {
          this.showGuideBinding()
          return
        }
        if (code === 1001) {
          this.$toast('礼包码已领完')
          return
        }
        this.$toast(msg)
      }).finally(() => this.receiveLoading = false)
      
    },
    receiveGiftCallback () {
      this.feedbackType = 1
      this.triggerVisible(true)
    },
    // handleClickDisable ({ status }) {
    //   if (status !== 1) return
    //   this.receiveGiftCallback()
    // },
    triggerVisible (v) {
      this.visible = v
    },
    showGuideBinding () {
      this.feedbackType = 2
      this.triggerVisible(true)
    },
    showGuidingImg ({ id, giftName }) {
      // 如果没有绑定角色信息
      this.feedbackType = 0
      this.triggerVisible(true)
      this.EVENT_TRACKING(
        EVENT_TYPE_ENUM.wechat_gift_center_not_bind_user_pop,
        {
          gift_id: id,
          gift_name: giftName,
        },
        this.trackAppInfo
      )
    },
    handleGetGameInfo () {
      return getGameInfoById({
        gameId: this.gameId
      }).then(res => {
        const { pic, name } = res.data
        this.pic = pic
        this.gameName = name
      })
    },
    handleGoMyGift () {
      this.$router.push({
        name: 'myGift',
        query: {
          tab: 1,
          gameId: this.gameId,
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.main {
  padding: 8px 10px;
  .account {
    background: #fff;
    padding: 12px;
  }

  .gift_title {
    width: 100%;
    img {
      width: 100%;
    }
  }

  .gift_list {
    overflow: auto;
    .gift + .gift {
      margin-top: 8px;
    }
  }
}
.img_container {
  min-height: 160px;
  transition: all .2s ease;
  img {
    width: 100%;
  }
}

</style>